import { Component, OnInit, Input, Output } from '@angular/core';
import { EventEmitter } from 'events';

@Component({
  selector: 'app-consulta-referencia-negocios',
  templateUrl: './consulta-referencia-negocios.component.html',
  styleUrls: ['./consulta-referencia-negocios.component.scss']
})
export class ConsultaReferenciaNegociosComponent implements OnInit {
  title = "REFERENCIAIS DE NÉGOCIOS";

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';
  msgNull = 'NÃO INFORMADO';

  constructor() { }

  ngOnInit() {
  }

}
